import { AchRecipientActivityFilter } from '@treasury/domain/ach';
import {
    type CurrencyRange,
    CurrencyRangeType,
} from '@treasury/presentation/components/tm-currency-range';
import { mapCurrencyRangeToDto } from '@treasury/presentation/components/tm-currency-range.mappings';

const defaultAmountRange: CurrencyRange = {
    rangeType: CurrencyRangeType.AllAmounts,
};

export class AchRecipientActivityFilterVm extends AchRecipientActivityFilter {
    constructor() {
        super();
        this.reset();
    }

    private _amountRange = defaultAmountRange;

    public get amountRange(): CurrencyRange {
        return this._amountRange;
    }

    public set amountRange(r: CurrencyRange) {
        this._amountRange = r;
        const { operator, fromAmount, toAmount, specificAmount } = mapCurrencyRangeToDto(r, false);
        this.amountType = operator || '';
        this.amountMin = fromAmount;
        this.amountMax = toAmount;
        this.amount = specificAmount;
    }

    public reset() {
        super.reset();
        this.amountRange = { ...defaultAmountRange };
    }
}
